'use client'

import { ReactNode, createContext, useContext, useMemo, useState } from 'react'

type NavSubMenuDialogContextValue = {
  isSubMenuOpen: boolean
  setIsSubMenuOpen: (isSubMenuOpen: boolean) => void
}

const NavSubMenuDialogContext = createContext<NavSubMenuDialogContextValue>({
  isSubMenuOpen: false,
  setIsSubMenuOpen: () => {},
})

export const NavSubMenuDialogProvider = ({ children }: { children?: ReactNode }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false)

  const value = useMemo(() => ({ isSubMenuOpen, setIsSubMenuOpen }), [isSubMenuOpen])

  return (
    <NavSubMenuDialogContext.Provider value={value}>{children}</NavSubMenuDialogContext.Provider>
  )
}

export const useNavSubMenuDialogState = () => useContext(NavSubMenuDialogContext)
